import React, { Fragment } from 'react';
import i18n from "../../../i18next";
import { connect } from 'react-redux';
import { Container, Row, Col, Button, Label, Input } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import { SortableContainer, SortableElement } from "react-sortable-hoc";

import SectionTitle from '../customerInsightScreen/SectionTitle';
import LabeledToggleElement from './LabeledToggleElement';
import AvField from 'availity-reactstrap-validation/lib/AvField';
import { AvInput } from 'availity-reactstrap-validation';
import CustomInsightsModal from '../customerInsightScreen/CustomInsightsModal';
import { FRONT_END_URL } from '../../../utils/Constants';


const SortableItem = SortableElement(({section, indexSection, key, styles, deleteSection, editTextSection}) => {
    const { navigationPanelItem, navigationPanelItemHeader } = styles;
    const imageName = section.imagePath ? section.imagePath.split('/') : null;
    
    return (
        <Col key={indexSection} sm={11} style={navigationPanelItem}>
            <div style={navigationPanelItemHeader}> 
                <div style={{cursor: 'pointer'}}>
                    <MaterialIcon icon="open_with" color="rgb(2, 136, 209)" size={25} />
                </div>
                <div style={{ fontWeight: 'bold' }}>
                    {
                        section.imagePath ? 
                        section.fileName : i18n.t('screens:marketingAutomationScreen.textBlock')
                    }
                </div>
                <div style={{display: 'flex'}}>
                    { !section.imagePath ? 
                        <div onClick={() => editTextSection(section)} style={{cursor: 'pointer', position: 'absolute', right: '45px'}}>
                            <MaterialIcon icon="edit" color="rgb(2, 136, 209)" size={25} />
                        </div> : null
                    }
                    <div onClick={() => deleteSection(indexSection)} style={{cursor: 'pointer'}}>
                        <MaterialIcon icon="delete" color="rgb(2, 136, 209)" size={25} />
                    </div>
                </div>
            </div>
            {
                section.paragraph ? 
                <div style={{textAlign: 'center', color: 'rgb(149, 149, 149)'}}>{section.paragraph}</div> : null
            }
            
        </Col>
    )
});

const SortableNavigationPanelItems = SortableContainer(({sections, styles, deleteSection, editTextSection}) => {

    return (
        <div id="sectionsContainer" style={{maxHeight: '650px', overflowY: 'auto', marginTop: '20px'}}>
            {sections.map((section, index) => {
                
                return (
                    <SortableItem
                        styles={styles}
                        key={`item-${index}`}
                        indexSection={index}
                        index={index}
                        section={section}
                        deleteSection={deleteSection}
                        editTextSection={editTextSection}
                    />
                )
            })}
        </div>
    )
});

class NavigationPanel extends React.Component {

    state = {
        isModalOpen: false
    }

    componentDidMount() {
       
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        })
    }

    onSortStart = () => {
        this.toggleDraggableCursor(true);
    };

    onSortEnd = (e) => {
        this.toggleDraggableCursor(false);
        this.props.reorderSectionItems(e.oldIndex, e.newIndex)
    };

    toggleDraggableCursor(set) {
        if (set) {
            document.getElementById("sectionsContainer").classList.add("dragCursor");
        } else {
            document.getElementById("sectionsContainer").classList.remove("dragCursor");
        }
    }

    renderModalBody() {
        const { sections, backgroundColor, backgroundImage } = this.props.emailTemplate;
        const { modalBodyContainer, modalBodyImage, modalBodyItemsWrapper } = styles;
            const containerWithBackgroundImageStyle = {
                backgroundImage: backgroundImage ? `url(${FRONT_END_URL}/${backgroundImage})` : null,
                backgroundSize: backgroundImage ? '100%' : null,
                minHeight: '78vh',
                backgroundColor: backgroundColor ? backgroundColor : null, 
                backgroundRepeat: backgroundImage ? 'repeat' : null,
                marginLeft: '10%', 
                marginRight: '10%', 
                padding :'10px 50px'
            }
            
            return ( 
                <div style={containerWithBackgroundImageStyle}>
                    {
                        sections ? sections.map((section, index) => {
                            const sectionParagraphStyles = {
                                fontSize: section.fontSize ? `${section.fontSize}px` : null,
                                color: section.textColor ? section.textColor : null,
                                textAlign: section.textAlignment ? section.textAlignment : null,
                                fontFamily: section.fontFamily ? section.fontFamily : null,
                                fontWeight: section.bold ? 'bold' : null,
                                fontStyle: section.italic ? 'italic' : null
                            }
                            
                            return (
                                <div key={index} style={modalBodyContainer}>
                                    {
                                        section.imagePath && !section.urlLink ?
                                        <div style={modalBodyItemsWrapper}>
                                            <img style={modalBodyImage} src={`${FRONT_END_URL}/${section.imagePath}`} />
                                        </div> : null
                                    }
                                    {
                                        section.imagePath && section.urlLink ?
                                        <div style={modalBodyItemsWrapper}>
                                            <a href={section.urlLink} target="_blank">
                                                <img style={modalBodyImage} src={`${FRONT_END_URL}/${section.imagePath}`} />
                                            </a>
                                        </div> : null
                                    }
                                    {
                                        (!section.imagePath && !section.urlLink) ?
                                        <div style={{...modalBodyItemsWrapper, ...sectionParagraphStyles}}>
                                            {section.paragraph}
                                        </div> : null
                                    }
                                </div>
                            )
                        }) : null
                    }
                </div>
             )
    }

    renderSections() {
        const { navigationPanelItem, navigationPanelItemHeader } = this.props.styles;

        if (this.props.emailTemplate.sections) {
            return (
                <Fragment>
                    <SortableNavigationPanelItems
                        axis='y'
                        lockToContainerEdges={true}
                        sections={this.props.emailTemplate.sections}
                        distance={15}
                        helperClass="draggableTemplateSections"
                        onSortStart={this.onSortStart}
                        onSortEnd={this.onSortEnd}
                        styles={this.props.styles}
                        deleteSection={this.props.deleteSection}
                        editTextSection={this.props.editTextSection}
                    />
                    {this.props.emailTemplate.sections.length > 0 ?
                        <p>{i18n.t('screens:marketingAutomationScreen.dragDropSections')}</p>
                        : null}
                </Fragment>
            )
        }
    }

    render() {
        const { sectionDiv, emailTemplateBtnsStyle, emailTemplateBtnsTextStyle } = this.props.styles;

        return (
            <Fragment>
                <div style={sectionDiv}>
                    <div>
                        <SectionTitle title={i18n.t('screens:marketingAutomationScreen.navigationPanel')} />
                        <button onClick={() => this.toggleModal()} color="primary" style={{...emailTemplateBtnsStyle, margin: '10px 10px 0', position: 'absolute', right: '40px', top: '5px', alignItems: 'center'}}>
                            <span style={emailTemplateBtnsTextStyle}>{i18n.t('common:buttons.menupreview')}</span>
                        </button>
                    </div>
                    <Col>
                    {this.renderSections()}
                    </Col>
                </div>
                {
                    this.state.isModalOpen ?
                    <CustomInsightsModal 
                    isOpen={this.state.isModalOpen}
                    onToggle={this.toggleModal.bind(this)}
                    header={i18n.t('screens:marketingAutomationScreen.preview')}
                    children={this.renderModalBody()}
                    className={'emailTemplateModal'}
                    /> : null
                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        marketingAutomations: state.marketingAutomations
    }
};

export default connect(mapStateToProps, {})(NavigationPanel);

const styles = {
    modalBodyContainer: {
        backgroundRepeat: 'repeat'
    },
    modalBodyItemsWrapper: {
        marginBottom: '25px'
    },
    modalBodyImage: {
        width: '100%',
        maxWidth: '600px',
        margin: 'auto',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/NavigationPanel.js